export type AccountFacilityStatus = {
	readonly value: string;
	readonly label: string;
};

export type AccountFacilityPayload = {
	readonly id: number;
	readonly name: string;
	readonly status: AccountFacilityStatus;
	readonly address: string | null;
	readonly phoneNumber: string | null;
	readonly organization: { readonly id: number };
};

export type AccountFacilitiesFetchedPayload = AccountFacilityPayload[];

export type AccountFacilitiesFetchedAction = {
	type: 'ACCOUNT_FACILITIES_FETCHED';
	payload: AccountFacilitiesFetchedPayload;
	accountId: number;
};

export default (
	payload: AccountFacilitiesFetchedPayload,
	accountId: number,
): AccountFacilitiesFetchedAction => ({
	type: 'ACCOUNT_FACILITIES_FETCHED',
	payload,
	accountId,
});
